import { BrowserModule } from '@angular/platform-browser';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'src/app/core/core.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared-modules/shared-modules.module';

import { PwaRoutingModule } from './pwa-routing.module';

import { DashboardComponent } from './kwikspace/dashboard/dashboard.component';
import { QuotesComponent } from "./kwikspace/quotes/quotes.component";
import { CustomersComponent } from "./kwikspace/customers/customers.component";
import { RentalsComponent } from "./kwikspace/rentals/rentals.component";
import { ProductsComponent } from "./kwikspace/products/products.component";
import { TransportComponent } from "./kwikspace/transport/transport.component";
import { ReportsComponent } from "./kwikspace/reports/reports.component";

import { ViewQuoteComponent } from "./kwikspace/quotes/view-quote/view-quote.component";
import { ViewRentalComponent } from "./kwikspace/quotes/view-quote/view-rental/view-rental.component";
import { ViewPurchaseComponent } from "./kwikspace/quotes/view-quote/view-purchase/view-purchase.component";
import { NewRentalQuoteComponent } from "./kwikspace/quotes/new-rental-quote/new-rental-quote.component";
import { EditRentalQuoteComponent } from "./kwikspace/quotes/edit-rental-quote/edit-rental-quote.component";
import { NewPurchseQuoteComponent } from "./kwikspace/quotes/new-purchase-quote/new-purchase-quote.component";
import { EditPurchaseQuoteComponent } from "./kwikspace/quotes/edit-purchase-quote/edit-purchase-quote.component";
import { NewDiagramComponent } from "./kwikspace/quotes/new-purchase-quote/new-diagram/new-diagram.component";
import { ExistingDiagramComponent } from "./kwikspace/quotes/new-purchase-quote/existing-diagram/existing-diagram.component";
import { ExistingTemplatesComponent } from "./kwikspace/quotes/new-purchase-quote/existing-templates/existing-templates.component";
import { PurchaseQuoteConfigComponent } from "./kwikspace/quotes/new-purchase-quote/purchase-quote-config/purchase-quote-config.component";

import { ViewCustomerComponent } from "./kwikspace/customers/view-customer/view-customer.component";
import { NewCustomerComponent } from "./kwikspace/customers/new-customer/new-customer.component";
import { EditCustomerComponent } from "./kwikspace/customers/edit-customer/edit-customer.component";

const providers = [];

@NgModule({
  declarations: [
    DashboardComponent,
    QuotesComponent,
    CustomersComponent,
    RentalsComponent,
    ProductsComponent,
    TransportComponent,
    ReportsComponent,
    ViewQuoteComponent,
    ViewRentalComponent,
    ViewPurchaseComponent,
    NewRentalQuoteComponent,
    EditRentalQuoteComponent,
    NewPurchseQuoteComponent,
    EditPurchaseQuoteComponent,
    ViewCustomerComponent,
    NewCustomerComponent,
    EditCustomerComponent,
    NewDiagramComponent,
    ExistingDiagramComponent,
    ExistingTemplatesComponent,
    PurchaseQuoteConfigComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    PwaRoutingModule,
    NgbModule,
    CoreModule,
    SharedModule,
  ],
  exports: [
  ]
})
export class PwaModule { }

@NgModule({})
export class KwikspaceModule {
  static forRoot(): ModuleWithProviders<KwikspaceModule> {
    return {
      ngModule: PwaModule,
      providers,
    };
  }
}

